import React from 'react';

// Theme toggle removed - platform operates in light heritage theme only
// These components are kept as no-ops for backwards compatibility

export const ThemeToggle = () => {
  // Hidden - no dark mode toggle
  return null;
};

export const ThemeSelector = () => {
  // Hidden - no theme selection
  return null;
};

export const ThemeSettingsPanel = () => {
  // Hidden - no theme settings
  return null;
};

export default ThemeToggle;
